import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

declare let paypal: any;

@Injectable({
  providedIn: 'root'
})
export class PaypalService {
  constructor(@Inject(DOCUMENT) private document: any) {}

  loadPaypalScript(): Promise<any> {
    return new Promise((resolve, reject) => {
      const scriptElement = this.document.createElement('script');
      scriptElement.src = 'https://www.paypalobjects.com/api/checkout.js';
      scriptElement.onload = resolve;
      document.body.appendChild(scriptElement);
    });
  }
}
